export default __webpack_public_path__ + "c0e8a2ad72567a108940e97ab92b9133.png";